module.exports = __webpack_public_path__ + "static/img/ayocpns.911537e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ayocpns.png
// module id = CjA3
// module chunks = 1